import {
    FETCH_FACILITIES_SUCCESS,
    FETCH_FACILITIES_FAILURE,
  } from "./actionTypes";
  
  const initialState = {
    facilities: [],
    error: null,
  };
  
  const facilities = (state = initialState, action) => {
    switch (action.type) {
      case FETCH_FACILITIES_SUCCESS:
        return {
          ...state,
          facilities: action.payload,
          error: null,
        };
      case FETCH_FACILITIES_FAILURE:
        return {
          ...state,
          facilities: [],
          error: action.payload,
        };
      default:
        return state;
    }
  };
  
  export default facilities;